module.exports = __webpack_public_path__ + "img/card-billing-history-hover.0ae611e7.svg";